export enum EUpdatePasswordResponseStatus {
  NO_ERROR = 0,
  INVALID_EMAIL_OR_PASSWORD = 400,
  INVALID_PASSWORD = 409,
  SERVER_ERROR = 500,
}
